import { useCallback } from 'react';
import { usePostMessageContext } from 'src/providers';

export function useExtensionDebugger() {
  const { postMessage } = usePostMessageContext();

  const debugAssertion = useCallback((message: string, pass: boolean) => {
    postMessage('debugAssertion', { message, pass });
  }, [postMessage]);

  const debugLog = useCallback((message: string, data: object = {}, level = 'info') => {
    postMessage('debugLog', { message, data, level });
  }, [postMessage]);

  return {
    debugAssertion,
    debugLog,
  };
}
